import { Component, OnInit, ViewChild } from '@angular/core';
import { ServerApiService } from "app/services/server-api.service";
import { StudentDataService } from "app/services/students/student-data.service";
import { forkJoin } from 'rxjs';

import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
// import { ReceiptsService, Receipt } from './receipts.service';
import { Receipt } from "app/models/interfaces/reveipt/receipt";
import { Invoice } from "app/models/interfaces/Invoice/Invoice";


@Component({
  selector: 'app-receipts',
  templateUrl: './receipts.component.html',
  styleUrls: ['./receipts.component.css']
})
export class ReceiptsComponent implements OnInit {
  receiptsSource  = new MatTableDataSource<Receipt>([]);
  invoicesSource  = new MatTableDataSource<Invoice>([]);



  receiptCols = [
    'receipt_number', 'receipt_date', 'receipt_type_name', 'amount', 'actions'
  ];

  invoiceCols = [
    'document_number', 'document_date', 'document_type_name', 'amount', 'actions'
  ];

  loading = false;
  error   = '';
  phone   = '';

  @ViewChild(MatSort) sort!: MatSort;;

  constructor( private serverApiService: ServerApiService,   private studentDataService: StudentDataService) { }
  user: any = null;

  ngOnInit(): void {

    this.user = this.studentDataService.user.user;
    console.log('this.user:', this.user);
    const data = {phone: this.user.mobileNumber}
    this.phone  = this.user.mobileNumber
    this.fetchReceipts()
  }
  ngAfterViewInit(): void {
    /* share same sorter; each table gets it when it’s rendered */
    this.receiptsSource.sort = this.sort;
    this.invoicesSource.sort = this.sort;
  }

  fetchReceipts(): void {
    const payload = { phone: this.phone };

    this.loading = true;
    this.error   = '';

    forkJoin([
      this.serverApiService.getReceiptsPerCustomer(payload), // Observable<Receipt[]>
      this.serverApiService.getInvoicePerCustomer(payload)   // Observable<Invoice[]>
    ])
    .subscribe(
      ([receipts, invoices]: [Receipt[], Invoice[]]) => {
        console.log('invoices=========>',invoices);
        this.receiptsSource.data = receipts;
        this.invoicesSource.data = invoices;
        this.loading = false;
      },
      (err) => {
        console.error('Error fetching data:', err);
        this.error =
          (err && err.error && err.error.message)
            ? err.error.message
            : 'Could not load data, please try again';
        this.loading = false;
      }
    );
  }

  // fetchReceipts(): void {
  //   const data = { phone: this.phone };

  //   this.loading = true;
  //   this.error = '';

  //   this.serverApiService.getReceiptsPerCustomer(data).subscribe({
  //     next: (receipts: Receipt[]) => {
  //       console.log('receipts======================>:', receipts);
  //       this.dataSource.data = receipts;
  //       this.loading = false;
  //     },
  //     error: err => {
  //       console.error('Error fetching receipts:', err);
  //       this.error =
  //         err?.error?.message || 'Could not load receipts, please try again';
  //       this.loading = false;
  //     }
  //   });
  // }


}
